import { AxiosResponse } from 'axios';
import { apisso } from './api';

type ValidTokenResponse = {
  has_valid_token: true;
  expires_at: string;
  time_remaining: string;
  created_at: string;
  state: string;
};

type InvalidTokenResponse = {
  has_valid_token: false;
  message: string;
  expires_at?: string;
};

export type CheckValidTokenResult = {
  hasValidToken: boolean;
  expiresAt?: string;
  timeRemaining?: string;
  createdAt?: string;
  state?: string;
  message?: string;
};


export const requestCodeSign = (
  cpf: string,
  email: string,
  token?: string,
): Promise<AxiosResponse> =>
  apisso.post(
    '/admin/assinatura/code/',
    {
      cpf,
      email,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

type AssinaturaProps = {
  code: string;
  state: string;
  identificador: string;
  tipo: string;
  internal_state: string;
  client_id: string;
  token?: string;
};

export const sendCodeSignToValidate = (
  params: AssinaturaProps
): Promise<AxiosResponse> =>
  apisso.post('/admin/assinatura/validar_codigo/', {
    client_id: params.client_id,
    code: params.code,
    identificador: params.identificador,
    internal_state: params.internal_state,
    state: params.state,
    tipo: params.tipo,
  }, {
    headers: {
      Authorization: `Bearer ${params.token}`,
    },
  });

export const checkCodeSignIsValid = (
  identificador: string,
  hash: string,
  token: string
): Promise<AxiosResponse> =>
  apisso.post(
    '/admin/assinatura/checar/',
    {
      identificador,
      hash,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  export const resendSignatureEmail = (
  cpf: string,
  email: string,
  token: string
): Promise<AxiosResponse> =>
  apisso.post(
    '/admin/assinatura/reenviar_email/',
    {
      cpf,
      email,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  export const checkValidToken = async (
  cpf: string,
  email: string,
  token?: string
): Promise<CheckValidTokenResult> => {
  try {
    const response = await apisso.post<ValidTokenResponse | InvalidTokenResponse>(
      '/admin/assinatura/verificar_token/',
      {
        cpf,
        email,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;

    if (data.has_valid_token) {
      const validData = data as ValidTokenResponse;
      return {
        hasValidToken: true,
        expiresAt: validData.expires_at,
        timeRemaining: validData.time_remaining,
        createdAt: validData.created_at,
        state: validData.state,
      };
    } else {
      const invalidData = data as InvalidTokenResponse;
      return {
        hasValidToken: false,
        message: invalidData.message,
        expiresAt: invalidData.expires_at, 
      };
    }
  } catch (error) {
    console.error('Error in checkValidToken:', error);
    return {
      hasValidToken: false,
      message: 'Erro ao verificar token de assinatura',
    };
  }
};
